<app-header></app-header>

<!-- ca să navighez între diferite rute -->
 <div class="main-wrapper">
<router-outlet></router-outlet>
</div>


<app-footer></app-footer>
